module.exports = __webpack_public_path__ + "static/img/040904.a6854c0d.png";